import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';
import Select from 'react-select';
import { Button } from '@material-ui/core';
import css from './bfm.css';

class LinkFeedForm extends Component {

    state = { bookId: null, RAHBankAccountId: this.props.feed.RAHBankAccountId, bankAccountId: this.props.feed.bankAccountId, R1BankAccountId: this.props.feed.R1BankAccountId };

    renderSelectInput = ({ input, options, name, id }) => (
        <Select
         {...input}
         id={id} 
         name={name} 
         styles={{ menuList: base => ({ ...base, maxHeight: '130px' }) }}
         options={options}
         onChange={value => input.onChange(value)}
         onBlur={() => input.onBlur(input.value)}
         value={options && options.find(option => option.isR1 ? option.value === this.state.R1BankAccountId : option.RAHBankAccountId === this.state.RAHBankAccountId)} 
         isClearable />
    )

    renderSelect = (bankaccounts, bankAccountId, isR1, clientAccountIds) => {
        const options = bankaccounts && bankaccounts.map(account => {
            account.label = account.AccountName;
            account.value = isR1 ? account.R1BankAccountID : account.RAHBankAccountId;
            account.isDisabled = false;
            account.isR1 = isR1;
            if (account.isMapped || !account.isActive ) {
                account.isDisabled = (bankAccountId && isR1 ? account.R1BankAccountID === bankAccountId : account.RAHBankAccountId === bankAccountId) || !clientAccountIds.includes(account.ClientAccountID)  ? false : true;
            }
            return account;
        })

        return <div className={[css.dFlex, css.pb20, css.alignCenter].join(' ')}>
                 <div>Bank</div>
                 <div className={[css.flex1, css.pl10].join(' ')}>
                    <Field
                        name="bankAccount"
                        component={this.renderSelectInput}
                        options={options} 
                        onChange={account => this.setState( isR1 ? { R1BankAccountId: account.value } : { RAHBankAccountId: account.RAHBankAccountId })} />
                 </div>
               </div>
    }

    onSave = (RAHBankAccountId, feed, isR1, isRAH, R1BankAccountId) => {
        if (isR1 ? feed.R1BankAccountId === R1BankAccountId : feed.RAHBankAccountId === RAHBankAccountId) return this.props.onClose();
        const updatedFeed = { ...feed };
        if (isRAH !== null && isRAH && !feed.RAHBankAccountId) {
            updatedFeed.RAHBankAccountId = RAHBankAccountId || null;
            return this.props.onLink(updatedFeed);
        } else if (isR1 !== null && isR1 && !feed.R1BankAccountId) {
            updatedFeed.R1BankAccountId = R1BankAccountId || null;
            return this.props.onLink(updatedFeed);
        }
        this.props.onSave();
    }

    render() {
        const { feed, bankAccounts, onClose, clientAccountIds, isRAH, isR1 } = this.props;
        const { RAHBankAccountId, R1BankAccountId } = this.state;
        const linkedAccount = bankAccounts && 
            isRAH ? bankAccounts.find(account => feed.RAHBankAccountId === account.RAHBankAccountId)
            : bankAccounts.find(account => feed.R1BankAccountId === account.value)

        const linkedAccountName = linkedAccount ? isRAH ? linkedAccount.AccountName : linkedAccount.label : 'Link';
        const linkedAccountId = linkedAccount ? isRAH ? linkedAccount.RAHBankAccountId : linkedAccount.value : null;

        return (
                <div className={css.w400}>
                    <p>{(Boolean(linkedAccount)) 
                        ? `This feed is currently mapped to ${linkedAccountName}. You can update the mapping by selecting a Bank account below`
                        : 'This feed is currently not mapped to any bank account. You can map it to a bank account by selecting the Bank account below'}</p>
                    {this.renderSelect(bankAccounts, linkedAccountId, isR1, clientAccountIds)}
                    <br /><br /><br /><br />
                    <div className={css.borderBottom} />
                    <div style={{display: 'flex', justifyContent: 'space-between'}}>
                        <Button variant="contained" size="small" component="span" onClick={onClose}>Close</Button>
                        <Button variant="contained" color="primary" size="small" component="span" onClick={() => this.onSave(RAHBankAccountId, feed, isR1, isRAH, R1BankAccountId)}>Save</Button>
                    </div>
                </div>
        );
    }
}

export default reduxForm({
    form: 'linkFeedForm',
    destroyOnUnmount: false,
})(LinkFeedForm)


// WEBPACK FOOTER //
// ./src/components/FeedManagment/LinkFeedForm.js